import _taggedTemplateLiteral from '../../../../../node_modules/@babel/runtime/helpers/taggedTemplateLiteral.es.js';
import { styled, css } from '@mgmresorts/wcl-styled';
import React, { useContext } from 'react';
import { Heading20, Text16 } from '../../Text/Text.es.js';
import { ViewportContext } from '../../ViewportContext/ViewportContext.es.js';
import '../../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';

var _templateObject, _templateObject2;
var StyledHeaderWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  pointer-events: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex-direction: column;\n  pointer-events: none;\n\n  /* fix for IE11 - cannot have nested @media queries */\n  ", "\n"])), function (p) {
  var topValue = p.viewport.minLg ? 25 : 15;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      /* this targets IE11 specifically through feature detection */\n      @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n        top: ", "px;\n      }\n    "])), topValue);
});
/**
 * Renders a <CenteredNavTitle /> component
 * @param {string} title - set the title of the element
 * @param {string} className - an optional param - set the class on the element
 **/

var CenteredNavTitle = function CenteredNavTitle(_ref) {
  var title = _ref.title,
      className = _ref.className,
      selectionDate = _ref.selectionDate;
  var viewport = useContext(ViewportContext);
  return /*#__PURE__*/React.createElement(StyledHeaderWrapper, {
    viewport: viewport,
    className: className
  }, viewport.minMd ? /*#__PURE__*/React.createElement(Heading20, {
    style: {
      pointerEvents: 'all'
    }
  }, title) : /*#__PURE__*/React.createElement(Text16, {
    style: {
      pointerEvents: 'all'
    }
  }, title), selectionDate && /*#__PURE__*/React.createElement(Text16, {
    style: {
      pointerEvents: 'all'
    }
  }, selectionDate));
};

export { CenteredNavTitle };
